/**
 * Ascolta errori di persistenza bozze su SQLite e mostra un toast.
 */

import React, { useEffect } from 'react';
import { useIonToast } from '@ionic/react';
import { DRAFT_PERSISTENCE_ERROR_EVENT } from '../consts/draft-persistence-events';

export interface DraftPersistenceErrorDetail {
  message: string;
}

export const DraftPersistenceErrorListener: React.FC = () => {
  const [presentToast] = useIonToast();

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent<DraftPersistenceErrorDetail>).detail;
      const message =
        detail?.message ??
        'Impossibile salvare la bozza in locale. Riprova più tardi.';
      void presentToast({
        header: 'Salvataggio bozza',
        message,
        duration: 5000,
        color: 'danger',
        buttons: [{ text: 'Chiudi', role: 'cancel' }],
      });
    };

    window.addEventListener(DRAFT_PERSISTENCE_ERROR_EVENT, handler);
    return () =>
      window.removeEventListener(DRAFT_PERSISTENCE_ERROR_EVENT, handler);
  }, [presentToast]);

  return null;
};
